<template>
  <div class="review-page">
    <div class="review-header">
      <h1>📖 单词复习</h1>
      <p class="subtitle" v-if="paperTitle">{{ paperTitle }}</p>
    </div>

    <div class="student-card" v-if="student">
      <div class="student-avatar">{{ student.username ? student.username.charAt(0).toUpperCase() : '?' }}</div>
      <div class="student-body">
        <div class="student-name">{{ student.username || student.nickname }}</div>
        <div class="student-meta">
          <span v-if="student.studentNo">学号 {{ student.studentNo }}</span>
          <span v-if="student.gradeName">{{ student.gradeName }}</span>
          <span v-if="student.className">{{ student.className }}</span>
        </div>
      </div>
    </div>

    <div class="word-list" v-if="words.length > 0">
      <div class="word-card" v-for="(item, index) in words" :key="index">
        <div class="word-index">{{ index + 1 }}</div>
        <div class="word-body">
          <div class="word-top">
            <span class="word-text">{{ item.word }}</span>
            <span class="word-pos" v-if="item.partOfSpeech">[{{ item.partOfSpeech }}]</span>
          </div>
          <div class="word-meaning">{{ item.chineseMeaning }}</div>
          <div class="word-phonetic" v-if="item.phoneticUk || item.phoneticUs">
            <span v-if="item.phoneticUk">英 {{ item.phoneticUk }}</span>
            <span v-if="item.phoneticUk && item.phoneticUs">&nbsp;|&nbsp;</span>
            <span v-if="item.phoneticUs">美 {{ item.phoneticUs }}</span>
          </div>
          <div class="word-audio">
            <button
              v-if="item.britishEnglishUrl"
              class="audio-btn"
              @click="playAudio(item.britishEnglishUrl, item.word, '英音')">
              <span class="vol-icon">🔊</span> 英
            </button>
            <button
              v-if="item.americanEnglishUrl"
              class="audio-btn"
              @click="playAudio(item.americanEnglishUrl, item.word, '美音')">
              <span class="vol-icon">🔊</span> 美
            </button>
          </div>
        </div>
      </div>
    </div>

    <div v-else class="loading-state">
      <p v-if="loading">加载中...</p>
      <p v-else>暂无单词数据</p>
    </div>
  </div>
</template>

<script>
import { getPaperWords } from '@/api/education/assessment'
import { Message } from 'element-ui'

export default {
  name: 'PaperReview',
  data() {
    return {
      paperTitle: '',
      student: null,
      words: [],
      loading: true
    }
  },
  async created() {
    const paperId = this.$route.params.id
    if (paperId) {
      await this.loadWords(paperId)
    } else {
      this.loading = false
    }
  },
  methods: {
    async loadWords(paperId) {
      try {
        const res = await getPaperWords(paperId)
        const data = res
        if (data) {
          this.paperTitle = data.paperTitle || ''
          this.student = data.student || null
          this.words = data.words || []
        }
      } catch (e) {
        console.error('加载单词列表失败', e)
      } finally {
        this.loading = false
      }
    },
    playAudio(url, word, type) {
      if (!url) return
      Message.info(`播放 ${word}，${type}`)
      new Audio(url).play().catch(e => {
        console.error('音频播放失败', e)
      })
    }
  }
}
</script>

<style>
* { margin: 0; padding: 0; box-sizing: border-box; }
body { background: #f0f2f5; font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif; }

.review-page {
  max-width: 640px;
  margin: 0 auto;
  padding: 16px;
  min-height: 100vh;
}

.review-header {
  text-align: center;
  padding: 20px 0 16px;
}
.review-header h1 {
  font-size: 22px;
  color: #303133;
}
.subtitle {
  font-size: 14px;
  color: #909399;
  margin-top: 6px;
}

.qr-section {
  margin-top: 12px;
  text-align: center;
}
.qr-img {
  width: 120px;
  height: 120px;
  border: 1px solid #e4e7ed;
  border-radius: 8px;
}
.qr-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 4px;
}

.student-card {
  display: flex;
  align-items: center;
  gap: 14px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  padding: 16px;
  margin-bottom: 16px;
  color: #fff;
}

.student-avatar {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background: rgba(255,255,255,0.25);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  font-weight: 700;
  flex-shrink: 0;
}

.student-body {
  flex: 1;
  min-width: 0;
}

.student-name {
  font-size: 16px;
  font-weight: 600;
  margin-bottom: 4px;
}

.student-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  font-size: 12px;
  opacity: 0.85;
}

.word-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.word-card {
  display: flex;
  background: #fff;
  border-radius: 12px;
  padding: 14px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.06);
  align-items: flex-start;
}

.word-index {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: #409eff;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  font-weight: 600;
  flex-shrink: 0;
  margin-right: 12px;
  margin-top: 2px;
}

.word-body {
  flex: 1;
  min-width: 0;
}

.word-top {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 6px;
}

.word-text {
  font-size: 18px;
  font-weight: 700;
  color: #303133;
}

.word-pos {
  font-size: 12px;
  color: #909399;
  font-style: italic;
}

.word-meaning {
  font-size: 15px;
  color: #606266;
  margin-top: 4px;
}

.word-phonetic {
  font-size: 13px;
  color: #909399;
  margin-top: 4px;
}

.word-audio {
  display: flex;
  gap: 8px;
  margin-top: 8px;
}

.audio-btn {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 5px 14px;
  border: 1px solid #dcdfe6;
  border-radius: 20px;
  background: #f5f7fa;
  color: #606266;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
  -webkit-tap-highlight-color: transparent;
  user-select: none;
}

.audio-btn:active {
  background: #409eff;
  color: #fff;
  border-color: #409eff;
}

.audio-btn:active .vol-icon {
  filter: brightness(10);
}

.vol-icon {
  font-size: 15px;
}

.loading-state {
  text-align: center;
  padding: 60px 0;
  color: #909399;
  font-size: 16px;
}

@media (max-width: 480px) {
  .review-page { padding: 12px; }
  .word-card { padding: 12px; }
  .word-text { font-size: 16px; }
}
</style>
